import { type FinancialAccountBalanceSummaryConstructor } from '../../entities/FinancialAccountBalanceSummary/FinancialAccountBalanceSummary'
import { type FinancialAccountBalanceSummaryApiModel } from '../api-models/FinancialAccountBalanceSummaryApiModel'

export const mapFinancialAccountBalanceSummaryApiModel = (
  data: FinancialAccountBalanceSummaryApiModel
): FinancialAccountBalanceSummaryConstructor => ({
  totalAmount: data.balance,
  availableAmount: data.available_funds,
  allocatedAmount: data.total_allocated_funds,
  amountAllocatedToSpendingCards: data.allocated_spending_card_funds,
  amountAllocatedToBillPayments: data.upcoming_bill_payments,
  currency: data.currency,
  isInsufficient: data.has_insufficient_funds_for_payment,
})
